export default __webpack_public_path__ + "static/media/logo_alternate.9cb70b59.svg";